import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import MembershipSelectionCard from "../onboarding/MembershipSelectionCard";
import { serverLine } from "../../../../controllers/network/serverLine";
import LoadingSection from "../../../helperComponents/LoadingSection";
import LoggedInMembershipPlanCard from "./LoggedInMembershipPlanCard";
import PrimaryButton from "../../../helperComponents/PrimaryButton";

import PullToRefresh from "react-simple-pull-to-refresh";
import fetchDataWithCaching from "../../../../controllers/network/fetchDataWithCaching";
import Context from "../../../../Context";
import { MdDone } from "react-icons/md";
import { t } from "i18next";
import ExistingMembershipPlan from "./ExistingMembershipPlan";
import transformToIdValuePair from "../../../../controllers/utils/transformToIdValuePair";
import ActivityBalance from "../rechargeActivity/ActivityBalance";
import SectionTitle from "../../../detailsPage/SectionTitle";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 0;
  margin-bottom: 20px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;

  @media (max-width: 900px) {
    flex-direction: column;
    width: 100%;
  }
`;

const PlanFeatures = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 16px;
  margin-bottom: 0;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 260px;
`;

const ExistingRequest = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  justify-content: center;

  padding: 40px 30px;
  border-radius: 20px;
  background: var(--surface);
  border: 1px solid var(--border);

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const LoggedInMembershipPlans = () => {
  const { membershipPlans, updateLoggedInUser } = useContext(Context);
  const [existingRequest, setExistingRequest] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activityTypes, setActivityTypes] = useState(null);

  useEffect(() => {
    loadStuff(false);
  }, []);

  if (loading) return <LoadingSection />;

  if (!activityTypes) return null;

  let activityTypesObj = transformToIdValuePair(activityTypes);

  async function loadStuff(skipCache) {
    let typesData = await fetchDataWithCaching({
      path: "/activity-types",
      setLoading,
      //set loading is disabled,
      // because in membership-request is null most of the time
      //null value is not cached
      //so it will make the loading things happen every time
      onFreshData: setActivityTypes,
      skipCache,
    });

    setActivityTypes(typesData);

    let data = await fetchDataWithCaching({
      path: "/membership-request",
      // setLoading,
      //set loading is disabled,
      // because in membership-request is null most of the time
      //null value is not cached
      //so it will make the loading things happen every time
      onFreshData: setExistingRequest,
      skipCache,
    });

    setExistingRequest(data);
    // await updateMembershipPlans();
    setLoading(false);
  }

  async function handleRefresh() {
    await updateLoggedInUser();
    await loadStuff(true);
  }

  // function handleRefresh() {
  //   return new Promise((resolve) => {});
  // }

  let requestComp = null;

  if (existingRequest) {
    requestComp = (
      <ExistingRequest>
        <SectionTitle style={{ textAlign: "center" }}>
          {t("membershipRequestSentTitle")} :{" "}
          {existingRequest.membershipPlan.name}
        </SectionTitle>

        <PrimaryButton style={{ width: "150px" }} onClick={cancelRequest}>
          {t("cancel")}
        </PrimaryButton>
      </ExistingRequest>
    );
  }

  let content = (
    <Container>
      {membershipPlans.map((item, index) => {
        if (item.status == "DISABLED") return null;
        return (
          <LoggedInMembershipPlanCard
            validityInWeeks={item.validityInWeeks}
            membershipPlanID={item._id}
            loadStuff={loadStuff}
            key={index}
            title={item.name}
            setLoading={setLoading}
            desc={item.description}
            price={item.price}
            name={item.name.toUpperCase()}
            features={
              <PlanFeatures>
                <PlanFeature>{item.feature1}</PlanFeature>
                <PlanFeature>{item.feature2}</PlanFeature>
                <PlanFeature>{item.feature3}</PlanFeature>
                {item.feature4 ? (
                  <PlanFeature>{item.feature4}</PlanFeature>
                ) : null}
              </PlanFeatures>
            }
          />
        );
      })}
    </Container>
  );

  // return content;

  return (
    <PullToRefresh onRefresh={handleRefresh}>
      {loading ? <LoadingSection /> : null}

      {requestComp}
      <br />
      <ActivityBalance activityTypeIdVsData={activityTypesObj} />
      {content}
    </PullToRefresh>
  );

  async function cancelRequest() {
    setLoading(true);

    try {
      await serverLine.post("/cancel-membership-request");
    } catch (e) {
      window.popupAlert(e.message);
    }

    await loadStuff();
    setLoading(false);
  }
};

const PlanFeatureContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
`;

const Tick = styled.div`
  height: 20px;
  width: 20px;

  background-color: var(--accentColor);
  color: var(--accentAlt);
  border-radius: 100px;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-right: 10px; */
  /* margin-top: -3px; */
`;

const PlanFeatureText = styled.div`
  width: 200px;
  font-size: 15px;
  line-height: 20px;
`;

function PlanFeature({ children }) {
  return (
    <PlanFeatureContainer>
      <Tick>
        <MdDone />
      </Tick>
      <PlanFeatureText>{children}</PlanFeatureText>
    </PlanFeatureContainer>
  );
}

export default LoggedInMembershipPlans;
